// 'use client';

// Third-party Imports
import classnames from 'classnames';

// Component Imports
import Logo from '../shared/Logo';
import ModeDropdown from '../shared/ModeDropdown';
import UserDropdown from '../shared/UserDropdown';

// Hook Imports
import useHorizontalNav from '../../../@menu/hooks/useHorizontalNav';

// Util Imports
import { horizontalLayoutClasses } from '../../../@layouts/utils/layoutClasses';
import { HorizontalNavToggle } from './NavToggle';

export const HorizontalNavbarContent = () => {
  // Hooks
  const { isBreakpointReached } = useHorizontalNav();

  return (
    <div
      className={classnames(horizontalLayoutClasses.navbarContent, 'flex items-center justify-between gap-4 is-full')}
    >
      <div className="flex items-center gap-4">
        <HorizontalNavToggle />
        {/* Hide Logo on Smaller screens */}
        {!isBreakpointReached && <Logo />}
      </div>
      <div className="flex items-center">
        <ModeDropdown />
        <UserDropdown />
      </div>
    </div>
  );
};
